// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__13bj-","content":"LayoutSettings_content__3J4j3"};